import { useCallback, useContext } from 'react';
import { ConfirmDialogContext } from './confirmDialogsContext';
export const useWithConfirmDialog = () => {
    const { setProps, setOpen } = useContext(ConfirmDialogContext);
    const wrapper = useCallback((props) => () => {
        setOpen(true);
        setProps({ ...props });
    }, [setProps, setOpen]);
    return wrapper;
};
//# sourceMappingURL=useWithConfirmDialog.js.map